module.exports = __webpack_public_path__ + "static/media/inapp_videos.18b54830.svg";